;(function () {

"use strict";

var metafieldInputTemplate = require('./templates/metafield-input.html');

var ConfigFormView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.url = opts.url || '/config';
    this.$appendTarget = opts.$appendTarget;

    if (!opts.noListeners) {
      window.App.Events.on('submit', _.bind(this.submit, this));
    }

    var self = this;
    this.$el.find('.object').each(function () {
      self.resetArrows($(this));
    });
  },
  add: function (e) {
    console.log('adding a meta field input row');
    var html;

    if ($(e.currentTarget).closest('div.object').hasClass("shop")) {
      console.log('SHOP');
      html = _.template(metafieldInputTemplate)({isShop: true});
    } else {
      html = _.template(metafieldInputTemplate)();
    }
    var $this = $(e.currentTarget);

    if (this.$appendTarget) {
      $(html).appendTo(this.$appendTarget);
    } else {
      $(html).insertBefore($this.parent());      
    }

    var $section = $this.closest('.object');
    this.resetArrows($section);

    return false;
  },
  remove: function (e) {
    var $this = $(e.currentTarget);
    var $section = $this.closest('.object');

    $this.closest('.form-group').remove();
    this.resetArrows($section);
  },
  generateData: function () {
    var data = {};
    var objectType, entry, $this, handle, datatype, entries;

    /* Clean this up! */
    this.$el.find('.object').each(function () {
      objectType = $(this).data('object-type');

      /* For object-config page */
      if (!objectType) {
        objectType = $(this).find('input.object-type').val();
      }

      entries = [];

      $(this).find('.form-group').not('.skip').each(function () {
        $this = $(this);
        handle = $this.find('input').val();
        datatype = $this.find('select').val();

        if (!handle) { return true; }

        entry = {};
        entry[handle] = datatype;
        entries.push(entry);
      });

      data[objectType] = entries;
    });

    return data;
  },
  submit: function () {
    console.log('submitting');
    var data = this.generateData();

    data.__shop__ = window.data.shop;

    $.post(this.url, {json: JSON.stringify(data)}, _.bind(function (d) {
      if (d.status === 'success') {
        this.success(d);
      } else {
        ShopifyApp.Modal.alert({
          title: d.err,
          message: 'Sorry, Something went wrong. Please try this action again or contact jason@thebestagency.com for more help.'
        });
      }
    }, this));

    return false;
  },
  success: function (d) {
    ShopifyApp.Modal.confirm({
      title: 'Success! Your Configuration has been updated.',
      message: 'You can now populate metafields for the specified objects. Do this by clicking on "Add Metafields" from the main menu.',
      okButton: 'Close Modal',
      cancelButton: 'Go Back to Homepage',
    }, function (result) {
      if (result) {
        window.location.reload();
      } else {
        ShopifyApp.internalRedirect('/');
      }
    });
  },
  resetArrows: function ($section) {
    console.log('resetting arrows');

    var $formGroups = $section.find('.form-group').not('.skip');
    console.log($formGroups[0]);
    $formGroups.find('.move-up, .move-down').attr('disabled', false);
    $formGroups.first().find('.move-up').attr('disabled', 'disabled');
    $formGroups.last().find('.move-down').attr('disabled', 'disabled');
  },
  moveMetafieldUp: function (e) {
    console.log('moving up');
    var $this = $(e.currentTarget).closest('.form-group');
    $this.insertBefore($this.prev());

    var $section = $this.closest('.object');
    this.resetArrows($section);
    e.preventDefault();
  },
  moveMetafieldDown: function (e) {
    console.log('moving down');
    var $this = $(e.currentTarget).closest('.form-group');
    $this.insertAfter($this.next());

    var $section = $this.closest('.object');
    this.resetArrows($section);
    e.preventDefault();
  },
  events: {
    'click .add-metafield': 'add',
    'click .remove-metafield': 'remove',
    'click .move-up': 'moveMetafieldUp',
    'click .move-down': 'moveMetafieldDown',
    'click .save': 'submit',
    'submit': 'submit'
  }
});

module.exports = ConfigFormView;

}());